module.exports = __webpack_public_path__ + "img/tanhuangzhizaoshebeijijishu.14172ef3.jpg";